module.exports = __webpack_public_path__ + "img/buy_crypto.36b19285.png";